var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"align":"center"}},[_c('img',{attrs:{"src":require("../../../assets/img/logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }